




















import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation } from 'vuex-class'

/**
 * Dialogo que solicita al usuario confirmación para eliminar una tarifa
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class DeleteRateConfirm extends Vue {
    @State(state => state.shipping.deletingRate)
    public deletingRate: boolean

    @Mutation('shipping/rate/deleting/set')
    public setDeletingRate: (deleting: boolean) => void
    public loading = false

    /**
     * Solicita a la aplicación la eliminación de la tarifa seleccionada por
     * el usuario
     */
    public async deleteRate () {
        this.loading = true
        await this.$store.dispatch('shipping/deleteRate')

        this.loading = false
    }

    public errorCaptured () {
        this.loading = false
        this.setDeletingRate(false)
    }
}
